export default __webpack_public_path__ + "static/img4-70a203db050531662ec49841bc6334f4.jpg";